import { Injectable } from "@angular/core";
// tslint:disable-next-line:no-var-requires
const heic2anyLib = require("heic2any");
const heic2any = heic2anyLib.default || heic2anyLib;

/**
 * Service to convert HEIC/HEIF images to JPEG for browser compatibility.
 * Chrome/Firefox don't display HEIC natively - converting before upload ensures preview works everywhere.
 */
@Injectable({
  providedIn: "root",
})
export class HeicConverterService {
  /**
   * Converts HEIC/HEIF file to JPEG if needed. Returns original file if not HEIC.
   * @param file - Input file (HEIC, HEIF, or any other format)
   * @param quality - JPEG quality 0-1 (default 0.92)
   * @returns Converted JPEG File or original file
   */
  async convertToJpegIfNeeded(file: File, quality: number = 0.92): Promise<File> {
    const isHeic =
      /\.(heic|heif)$/i.test(file.name) || ["image/heic", "image/heif"].includes(file.type.toLowerCase() || "");
    if (!isHeic) return file;

    try {
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality,
      });
      const jpegBlob = Array.isArray(blob) ? blob[0] : blob;
      const newName = file.name.replace(/\.(heic|heif)$/i, ".jpg");
      return new File([jpegBlob], newName, { type: "image/jpeg" });
    } catch (err) {
      console.warn("HEIC conversion failed, returning original:", err);
      return file;
    }
  }
}
